import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { AlertProps } from "@/types";
import { Typography } from "../content";


/**
 * Displays a generic alert.
 */
const __default__ = {
  name: "AlertCard",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: {},
    message: {}
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => {
  switch (props.type) {
    case "error":
      return "bd-negative q-pa-sm nav-alert";
    case "success":
      return "bd-positive q-pa-sm nav-alert";
    case "warning":
      return "bd-secondary q-pa-sm nav-alert";
    default:
      return "bd-primary q-pa-sm nav-alert";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    bordered: "",
    class: _normalizeClass(className.value)
  }, {
    default: _withCtx(() => [
      (!!props.message)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 0,
            value: props.message
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})